import { AutogenModelFreightMatchingDataOutput, AutogenRowFreightMatchingDataOutput } from "./autogen/AutogenModelFreightMatchingDataOutput";

export class ModelFreightMatchingDataOutput extends AutogenModelFreightMatchingDataOutput<RowFreightMatchingDataOutput> {
	constructor() {
		super(RowFreightMatchingDataOutput);
	}
}

export class RowFreightMatchingDataOutput extends AutogenRowFreightMatchingDataOutput {
}